// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"87a67898","362":"430aabea","391":"52837024","415":"a2c923bb","557":"48275460","672":"0e5caa49","677":"ca38d907","751":"4f0284cf","780":"e3cdf599","786":"3e581167","830":"c2fdbf22","839":"ffdb525f","871":"89a71db7","950":"beef4e32","981":"225f8b99"}[chunkId] + ".chunk.js";
};